import { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Container from '../../../../components/Container'
import { useLoading } from '../../../../hooks/loading'
import api from '../../../../services/api'
import { FormExpense } from '../components/Form'
import { apiList } from '../domain/api'
import { nameActions } from '../domain/info'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { useToast } from '../../../../hooks/toast'

const Update = (): JSX.Element => {
  const { addToast } = useToast()
  const location = useLocation()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [expenseItem, setExpenseItem] = useState<{
    id?: number
    provider_id?: number
    provider?: {
      company_social_name: string
    }
    financialMovimentType: {
      financial_moviment_type_group_id: number
    }
    financial_moviment_type_id: number
    description: string
    due_date?: Date
    value: string
    fees_fines_value?: string
    nf_number?: number
    finished: string
    payment_method?: string
    recurrence?: number
    operation_type: string
    generated_user_id?: number
    downloaded_at?: Date
    category_id: number
    sub_category_id: number
  }>()

  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiList(id))
        const { data } = response
        setExpenseItem(data)
        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o usuário',
          description:
            'Houve um error ao carregar o usuário, tente novamente mais tarde!'
        })
        if (path.includes('update')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }
    loadData()
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])

  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate}
    >
      <FormExpense
        typeForm="update"
        initialValues={{
          idUpdate: Number(expenseItem?.id),
          ...expenseItem
        }}
      />
    </Container>
  )
}

export default Update
